import { catchError } from "rxjs/operators";
import { CookiesStorageService } from "../services/cookies-storage.service";
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(
    private cookieStorage: CookiesStorageService,
    private router: Router
  ) {}

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    //handle your auth error or rethrow
    if (err.status === 401 || err.status === 403) {
      this.cookieStorage.delete(CookiesStorageService.USER_TOKEN);
      this.router.navigate(["/login"], {});
      return throwError(() => err);
    }
    return throwError(() => err);
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next
      .handle(request)
      .pipe(catchError((x) => this.handleAuthError(x)));
  }
}
